<template>
  <div class="h-full bg-gray-300 p-6">
    <div class="flex items-center gap-6">
      <div class="flex w-1/2 flex-col gap-4">
        <div
          class="flex items-center gap-2"
          v-for="prop in props"
          :key="prop.label"
        >
          <ontick-switch-component
            :active="prop.value"
            @switch="switchProp(prop)"
          />
          <label class="text-ontick-carbon-900">
            {{ prop.label }}
          </label>
        </div>
        <div class="text-ontick-carbon-900 flex flex-col gap-2">
          <label for="">Tipos:</label>
          <div class="flex items-center gap-2">
            <input type="radio" value="date" v-model="type" />
            <label class=""> Date </label>
          </div>
          <div class="flex items-center gap-2">
            <input type="radio" value="datetime" v-model="type" />
            <label class="">
              Datetime (pode não funcionar direito com range ativado)</label
            >
          </div>
        </div>
      </div>

      <div class="w-1/2">
        <ontick-datetime-picker
          v-model="selectedDate"
          v-bind="formattedProps"
          :type="type"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OntickSwitchComponent from "../../../../shared/components/basic/ontick-switch.component.vue";
import ontickDatetimePicker from "../../../../shared/components/datetime-picker/ontick-datetime-picker.component.vue";
export default {
  components: {
    ontickDatetimePicker,
    OntickSwitchComponent,
  },
  data() {
    return {
      selectedDate: {},
      key: Math.floor(Math.random() * 100000),
      props: {
        range: { value: true, label: "Range" },
        allowPast: { value: true, label: "Allow past" },
        allowFuture: { value: true, label: "Allow future" },
        enableShortcuts: { value: true, label: "Enable shortcuts" },
      },
      type: "date",
    };
  },

  computed: {
    formattedDate() {
      if (!Object.keys(this.selectedDate).length) return null;
      return {
        start: this.moment(this.selectedDate.start).format(),
        end: this.moment(this.selectedDate.end).format(),
      };
    },
    formattedProps() {
      return {
        range: this.props.range.value,
        allowPast: this.props.allowPast.value,
        allowFuture: this.props.allowFuture.value,
        enableShortcuts: this.props.enableShortcuts.value,
      };
    },
  },

  methods: {
    switchProp(prop) {
      if (prop.label === "Enable time picker" && prop.value == false) {
        this.props.range.value = false;
        prop.value = true;
      } else {
        prop.value = !prop.value;
      }
    },
  },
};
</script>

<style></style>
